module.exports = __webpack_public_path__ + "img/Oslo.5a11f13b.jpg";